module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersWidgetSelect":{"deselect":"- Vyberte -"}}}')
  delete Component.options._Ctor
}
